import React from 'react';
import { Advertisers } from '../components/Advertisers';

export const AdvertisingPage = () => {
  return (
    <div className="pt-16">
      <Advertisers />
    </div>
  );
};